import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import { Grid,Button } from "@mui/material";
import { getLogin } from "redux/actions/authAction";

function Timer(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [timerValue, setTimerValue] = useState(60); // Set an initial timer value
  const [isResendActive, setIsResendActive] = useState(false); // Set initial state of the resend button

  useEffect(() => {
    callIntervalFunction() // Clean up the interval on component unmount
  }, []);

  const callIntervalFunction = () => {
    const interval = setInterval(() => {
      setTimerValue((prevTimerValue) => {
        if (prevTimerValue === 1) {
          setIsResendActive(true); // Timer reached 0, enable the resend button
          clearInterval(interval); // Stop the timer
        }
        return prevTimerValue - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }

  const OnResend = () => {
    const mobile = localStorage.getItem('mobile')
    const code = localStorage.getItem('code')

    const userDetails = {
      platform: 'FrontDeskApp',
      "mobileOrEmail": mobile,
      "countryCode": code
    }
    dispatch(getLogin(userDetails, navigate))
    setIsResendActive(false)
    setTimerValue(30)
    callIntervalFunction();
    props?.onResend();
  }

  return (
    <div>
      <Grid
        container
        direction="row"
        alignItems="center"
        spacing={2}
      >
        <Grid item>
          {!isResendActive && <CountdownCircleTimer
            isPlaying
            size={50}
            strokeWidth={5}
            isGrowing="true"
            rotation="clockwise"
            duration={60}
            colors={["#0f538D"]}

          >
              {({ remainingTime }) => (
              <div className="colorPrimary">
                {remainingTime} <span className="font7">Sec</span>
              </div>
            )
            }
          </CountdownCircleTimer>}
        </Grid>

        <Grid item>
          <Button
            className={`textDecorationUnderLine ${isResendActive ? "otpResend colorPrimary" : "otpResend colorGrey"}`}
            disabled={!isResendActive}
            onClick={() => OnResend()}
          >
            Resend
          </Button>
        </Grid>
      </Grid>
    </div>
  );
}

export default Timer;
